import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'tsu-review',
  templateUrl: './review.component.html',
  styleUrls: ['./review.component.scss']
})
export class ReviewComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
